import { DEAL_ACTIVITY_EVENTS_LISTING } from './dealActivityEventsListing';
import { DEAL_ACTIVITY } from './dealActivityEvent';

export * from './types';
export * from './usaCalendar';

export const calendarApi = {
  dealActivityEventsListing: DEAL_ACTIVITY_EVENTS_LISTING,
  dealActivity: DEAL_ACTIVITY,
};
